(function () {
    "use strict";

    angular
        .module("app")
        .directive("businessSegmentSearchHelp", ["SearchFactory", businessSegmentSearchHelp]);

    function businessSegmentSearchHelp(searchFactory) {
        return {
            restrict: "E",
            link: function (scope) {

                scope.search = function (forValidation) {
                    if (scope.readOnly === true) {
                        return;
                    }

                    if (forValidation && (!scope.displayValue || scope.displayValue.trim().length === 0)) {
                        scope.businessSegmentName = "";
                        scope.prevDisplayValue = "";
                        scope.displayValue = "";
                        return;
                    }

                    scope.needToValidate = forValidation ? true : false;

                    if (forValidation && (scope.prevDisplayValue === scope.displayValue || scope.businessSegmentName === scope.displayValue)) {
                        
                        scope.needToValidate = false;
                        return;
                    }

                    var modalSearch = searchFactory.businessSegmentSearch(function (businessSegment) {
                        scope.businessSegmentName = businessSegment ? businessSegment.BusinessSegmentName : "";
                        scope.displayValue = scope.businessSegmentName;

                        if (scope.prevDisplayValue !== scope.displayValue) {
                            scope.setDirtyCallback();
                        }

                        scope.prevDisplayValue = scope.displayValue;
                        scope.needToValidate = false;
                    });

                    modalSearch.startSearch(forValidation, [scope.displayValue]);
                };

                scope.$watch("businessSegmentName", function (newValue) {
                    scope.displayValue = newValue;
                });


                scope.displayValue = scope.businessSegmentName;
                scope.prevDisplayValue = scope.displayValue;

            },
            scope: { businessSegmentName: "=", readOnly: "=", needToValidate: "=", setDirtyCallback: "&" },
            templateUrl: templateUrl("app/directives/searchHelp/searchHelp.directive.html")
        };
    }
})();

